import { render, staticRenderFns } from "./DetailAnggota.vue?vue&type=template&id=d83ad7be&scoped=true&"
import script from "./DetailAnggota.vue?vue&type=script&lang=js&"
export * from "./DetailAnggota.vue?vue&type=script&lang=js&"
import style0 from "./DetailAnggota.vue?vue&type=style&index=0&id=d83ad7be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d83ad7be",
  null
  
)

export default component.exports